module.exports = __webpack_public_path__ + "media/images/app/header/chevron-right-e4107bd1bdd69ebe6b47212afba7e820.svg";